type DotNotation = {
  [key: string]: undefined | boolean | string | number | null;
};

export function getDotNotation(
  obj: Record<string, any>, 
  prefix: string = '',
  priorityOrder: string[] = []
): DotNotation {
  const entries = Object.entries(obj).reduce((acc: DotNotation, [key, value]) => {
    const isNested = (value !== null && typeof value === 'object' && !Array.isArray(value));
    const processedKey = isNested ? capitalize(key) : key;

    const newKey = prefix ? `${prefix}.${processedKey}` : processedKey;

    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      return { ...acc, ...getDotNotation(value, newKey) };
    }

    if (Array.isArray(value)) {
      return { ...acc, [newKey]: JSON.stringify(value) };
    }

    return { ...acc, [newKey]: value };
  }, {});

  const sortEntries = (a: [string, any], b: [string, any]): number => {
    const aKey = a[0].toLowerCase();
    const bKey = b[0].toLowerCase();

    const aPriority = priorityOrder.findIndex(term => {
      const key = aKey.split('.').shift();
      return key === term.toLowerCase();
    });
    const bPriority = priorityOrder.findIndex(term => {
      const key = bKey.split('.').shift();
      return key === term.toLowerCase();
    });

    if (aPriority !== -1 && bPriority !== -1) {
      return aPriority - bPriority;
    }

    if (aPriority !== -1) return -1;

    if (bPriority !== -1) return 1;

    return aKey.localeCompare(bKey);
  };

  return Object.fromEntries(Object.entries(entries).sort(sortEntries));
}

export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}